module.exports = __webpack_public_path__ + "img/covid_carsharing.822e80ab.png";